import { Queue } from '../graphql/components';

export const getQueue = (queues: Queue[], id: string) => queues.find((queue) => queue.id === id);

export const getQueueNamesByIds = <T extends string | number>(queues: Queue[], queueIds: T[]) =>
  queueIds.map((queueId) => getQueue(queues, queueId.toString())?.name);
